import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { capitalizeWords } from 'utils/string_utils';

const Wrap = styled.div`
  border: 1px solid var(--vo-cloud);
  border-radius: 10px;
  overflow: hidden;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
`;

const Th = styled.th`
  font-size: 11px;
  font-weight: 600;
  color: var(--vo-slate);
  text-transform: uppercase;
  letter-spacing: .08em;
  padding: 10px 14px;
  background: var(--vo-mist);
  border-bottom: 1px solid var(--vo-cloud);
  text-align: ${p => p.$center ? 'center' : 'left'};
`;

const AreaTd = styled.td`
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 500;
  color: var(--vo-ink);
  border-bottom: 1px solid var(--vo-mist);
`;

const NumTd = styled.td`
  padding: 10px 14px;
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  color: ${p => p.$color};
  border-bottom: 1px solid var(--vo-mist);
`;

const NoDataTd = styled.td`
  padding: 10px 14px;
  font-size: 13px;
  color: var(--vo-slate);
`;

export const IndicatorAreaDatas = ({ indicatorAreaDatas }) => {
  const { t } = useTranslation('mapping');
  return (
    <Wrap>
      <Table>
        <thead>
          <tr>
            <Th>{t('ropa.executiveSummary.areaName')}</Th>
            <Th $center>{t('ropa.executiveSummary.personalDataPlural')}</Th>
            <Th $center>{t('ropa.executiveSummary.sensitivePersonalDataPlural')}</Th>
            <Th $center>{t('ropa.executiveSummary.legalBasesPlural')}</Th>
          </tr>
        </thead>
        <tbody>
          {(indicatorAreaDatas ?? []).map((item, i) => (
            <tr key={i}>
              <AreaTd>{capitalizeWords(item.name)}</AreaTd>
              <NumTd $color="var(--vo-celeste)">{item.personalDataQuantity}</NumTd>
              <NumTd $color="var(--vo-danger)">{item.sensitivePersonalDataQuantity}</NumTd>
              <NumTd $color="var(--vo-success)">{item.legalBaseQuantity}</NumTd>
            </tr>
          ))}
          {(!indicatorAreaDatas || indicatorAreaDatas.length === 0) && (
            <tr>
              <NoDataTd colSpan={4}>{t('ropa.executiveSummary.noRecords')}</NoDataTd>
            </tr>
          )}
        </tbody>
      </Table>
    </Wrap>
  );
};
